import { useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "src/@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "src/@/components/ui/dialog";
import { Input } from "src/@/components/ui/input";
import { Label } from "src/@/components/ui/label";
import v2_actionCriarAutomacao from "src/actions/v2/automacoes/v2_actionCriarAutomacao";

export default function DialogCriarAutomacao({user, onCallback}) {
    const [automationName, setAutomationName] = useState("");
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const handleCreate = async () => {
        // Handle the creation logic here (e.g., API call)
        let data = {
            scope: {
                name: automationName,
                userId:user.id
            }

        }
        try {
            const response = await v2_actionCriarAutomacao(user.clienteId, data);
            setAutomationName("");
            setOpen(false);
            onCallback(response.data.data);
            navigate(`/dashboard/automacoes/${response.data.data._id}`);

        } catch (error) {
            console.error(error);
        }
        setAutomationName(""); // Reset input
    };

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            {/* Button to open modal */}
            <DialogTrigger asChild>
                <Button className="bg-purple-600 text-white rounded-md px-4 hover:bg-purple-700">
                    Criar nova automação
                </Button>
            </DialogTrigger>

            {/* Modal Content */}
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Nova Automação</DialogTitle>
                    <DialogDescription>
                        Preencha o nome da automação abaixo e clique em "Criar" para continuar
                    </DialogDescription>
                </DialogHeader>

                {/* Input for Automation Name */}
                <div className="space-y-4">
                    <div>
                        <Label htmlFor="automation-name" className="text-sm font-medium">
                            Nome
                        </Label>
                        <Input
                            id="automation-name"
                            type="text"
                            placeholder="Digite o nome da automação"
                            value={automationName}
                            onChange={(e) => setAutomationName(e.target.value)}
                            className="w-full"
                        />
                    </div>
                </div>

                {/* Footer with Actions */}
                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => {
                            setAutomationName("");
                            setOpen(false);
                        }}
                        className="text-gray-700"
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleCreate}
                        className="bg-purple-600 text-white hover:bg-purple-700"
                    >
                        Continuar
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
